import React from 'react';
import * as R from 'ramda';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// forms
import { Fieldset2 } from '../../../forms';
// helpers/constants
import * as G from '../../../helpers';
//////////////////////////////////////////////////

const SimpleForm = (props) => {
  const {
    isSubmitting,
    handleSubmit,
    fieldSettings,
    isReadOnlyMode,
    optionsForSelect = {},
    fieldsWrapperStyles = {},
  } = props;

  const submitBtnStyles = G.ifElse(isReadOnlyMode, { display: 'none' }, {});

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset2
        {...G.getFormikPropsToFieldset(props)}
        {...optionsForSelect}
        fields={fieldSettings}
        fieldsWrapperStyles={{ px: '0px', pt: 15, flexDirection: 'column', ...fieldsWrapperStyles }}
      />
      <FormFooter submitDisabled={isSubmitting} submitBtnStyles={submitBtnStyles} />
    </form>
  );
};

const enhance = compose(
  withFormik({
    enableReinitialize: true,
    validationSchema: R.path(['validationSchema']),
    mapPropsToValues: R.pathOr({}, ['initialValues']),
    handleSubmit: (values, { props, setSubmitting }) => {
      const { submitAction } = props;

      const callback = () => setSubmitting(false);

      const data = G.mapObjectEmptyStringFieldsToNull(values);

      submitAction(data, { failCallback: callback, successCallback: callback });
    },
  }),
  pure,
);

export default enhance(SimpleForm);
